import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles, used in theme property. Please note that the css is conflicting with tailwindcss, so the css is hardcoded in src/style folder as a global css

export default function TextEditor({
  value,
  setValue,
  placeholder,
  className,
}) {
    const modules = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['link', 'image'],
        ['code-block'], // code block button
      ],
    };
  
    const formats = [
      'bold', 'italic', 'underline', 'link',
      'list', 'bullet', 'indent', 'image', 'color', 'background',
      'align', 'direction', 'code-block', 'script'
    ];

  return <div>
    <ReactQuill 
      theme="snow" 
      value={value} 
      onChange={setValue} 
      modules={modules}
      formats={formats}
      placeholder={placeholder || ""}
      className={className || ""}
    />
  </div>
}